module.exports = __webpack_public_path__ + "static/Bear-16f8a98c09194089f573dc2f2557f5f0.jpg";